import { Plugin } from 'ckeditor5';

export default class FixLinkImageFocus extends Plugin {
	static get pluginName() { return "FixLinkImageFocus" }

	init() {
		const editor = this.editor;

		if (editor.plugins.has('LinkUI')) {
			let linkUIPlugin = editor.plugins.get('LinkUI');

			linkUIPlugin._balloon.on('change:visibleView', (eventInfo, eventName, value, oldValue) => {
				if (this._isLinkActionsView(value) && oldValue) {
					eventInfo.source.editor.editing.view.focus();
				}
			});
		}
	}

	_isLinkActionsView(balloonView) {
		if (balloonView && balloonView.template && balloonView.template.attributes && balloonView.template.attributes.class) {
			return balloonView.template.attributes.class.indexOf('ck-link-actions') >= 0;
		}

		return false;
	}
}